import { observable } from 'mobx';
import { createContext } from 'react';

// class CounterStore {
//   @observable amountIncomes = 50;
// }

const SavingCapacityStore = observable({
  incomes: 0,
  expenses: 0,
  capacity: 0,
});

SavingCapacityStore.setValue = function(name, value) {
  this[name] = value.toFixed(2);
  this.capacity = (this.incomes - this.expenses).toFixed(2);
};

const SavingCapacityStoreContext = createContext(SavingCapacityStore);

export default SavingCapacityStoreContext;
